import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable }     from 'rxjs/Observable';
import { Page } from '../../Models/pages';
import { UserService, SeedDataService, AuthenticationService, ProfileDataService } from '../../Services/index';

@Component({
   // moduleId: module.id,
    templateUrl: './dashboardlayout.component.html'
    

})

export class DashboardLayoutComponent {
  //  cities: SelectItem[];
    pages: Page[];
    selectedCity: string;
    currUser: any;
    fullname: string;
    IsAdmin: boolean = false;
    userImg: string;
    IsDelete: boolean;
    IsSave: boolean;
    
    constructor(private route: ActivatedRoute,
        private router: Router,private profiledataservice: ProfileDataService,private authenticationService: AuthenticationService) {
        this.userImg = '../../../UserPhoto/male.png';
        if (JSON.parse(window.localStorage.getItem('pagedetails')) != null) {
            this.pages = JSON.parse(window.localStorage.getItem('pagedetails'));
            if (router.url != '/home') {
                var requestedPageName = router.url.split('/')[1];
                var isValid = false;
                for (var i = 0; i < this.pages.length; i++) {                    
                    var allowedPageName = this.pages[i].url.split('/')[1];
                    //if (this.pages[i].url == router.url) {
                    if (allowedPageName == requestedPageName){
                        if (this.pages[i].permissionID == 1)
                        {
                            this.IsDelete = false;
                            this.IsSave = false;
                        }
                        if (this.pages[i].permissionID == 2) {
                            this.IsDelete = false;
                            this.IsSave = true;
                        }
                        if (this.pages[i].permissionID == 3) {
                           
                            this.IsDelete = true;
                            this.IsSave = true;
                        }
                        isValid = this.pages[i].assigned;
                    }
                    if (i == this.pages.length - 1 && !isValid) {
                        this.router.navigate(['/home']);
                    }

                }
            }

        } else {


            this.authenticationService.GetPagesByUserID(JSON.parse(window.localStorage.getItem('currentUser')).UserId)
                .subscribe(
                data => {
                    window.localStorage.setItem('pagedetails', JSON.stringify(data));

                    this.pages = data;
                });
        }
        var currUser = JSON.parse(window.localStorage.getItem('currentUser'));

        this.fullname = currUser.fullname;
       
        if (currUser.RoleName =='Admin' )
        {
            this.IsAdmin = true;
        }
        this.profiledataservice.GetUserPhoto(JSON.parse(window.localStorage.getItem('currentUser')).UserId).subscribe(data1 => {

            this.userImg = '../../../' + data1 + "?" + (new Date());
            if (this.userImg.indexOf('male.png') > -1) {
                
            } else {
               
            }

        });

    }    

    Logout() {

        this.authenticationService.logout();

    }

    
}



// WEBPACK FOOTER //
// ./src/app/Components/dashboard/dashboardlayout.component.ts